import { Path, Tool, Point, PointText, Color, rotate} from 'paper';
import store from '../store';
import { MaterialCircle } from '../shapes/toolshapes/MaterialCircle';
import { CutCircle } from '../shapes/toolshapes/CutCircle';
import PathUtils from '@/services/PathUtils';

let local ={
    path: null,
    defaultProportion: 1
};

function onActivate() {

    let radius = store.getters.materialName == "Bois" ? 120 : 50;
    let otherShapes = store.getters.shapes;
    let shapePoint = new Point(0, -radius);
    let newShape;
    
    if (store.getters.toolType == 'cut') {
        let otherCut = otherShapes.filter(s=> s.type.startsWith('cut'));
        let selectedShape = store.getters.selectedShape;
        let parentBound = selectedShape.bounds;
        let selectedShapeCenter = parentBound.center;
        let cuttingOptions = store.getters.cuttingOptions;
        let minSize = parentBound.width >= parentBound.height ? parentBound.height : parentBound.width ;
        minSize = minSize/100 * 20;
        minSize = (minSize*2) < cuttingOptions.minimalInternalArea ? cuttingOptions.minimalWidth : minSize;
        if(selectedShape.type == "materialtriangle"){
            var summitPoint = new Point((selectedShape.size.width * selectedShape.heightPos),0).add(parentBound.topLeft);
            var newCenterX = (summitPoint.x + parentBound.bottomLeft.x + parentBound.bottomRight.x)/3;
            var newCenterY = (summitPoint.y + parentBound.bottomLeft.y + parentBound.bottomRight.y)/3;
            shapePoint = new Point(newCenterX,newCenterY).rotate(selectedShape.rotation, parentBound.center); 
        }else{
            shapePoint = selectedShapeCenter;
        }
        
        radius = (minSize)/2;
        newShape = new CutCircle(shapePoint, radius,false);
        newShape.updatePath();
        let newShapeBounds = newShape.item().bounds;
        while(otherCut.some(s=> newShapeBounds.intersects(s.item().bounds))){
            newShapeBounds.center = newShapeBounds.center.add(cuttingOptions.minimalHeight+50,0);
            newShape.center = newShapeBounds.center;
           
        }
    }
    else{
        if(otherShapes.length >= 1){
            let distanceToOrigin = otherShapes[0].item().bounds.center.getDistance(new Point(0,0));
            let closestShape = otherShapes[0];
            for (let index = 0; index < otherShapes.length; index++) {
                const shapeDistance = otherShapes[index].item().bounds.center.getDistance(new Point(0,0));
                if(shapeDistance <= distanceToOrigin){
                    distanceToOrigin = shapeDistance;
                    closestShape = otherShapes[index];
                } 
            }
            shapePoint = shapePoint.add(closestShape.sizeW + 10, 0);
        }
        
        newShape = new MaterialCircle(shapePoint, radius);
        newShape.updatePath();
        let newShapeBounds = newShape.item().bounds;
        while(otherShapes.some(s=> newShapeBounds.intersects(s.item().bounds))){
            newShapeBounds.center = newShapeBounds.center.add(200,0);
            newShape.center = newShapeBounds.center;
           
        }
    }

    newShape.updatePath();
    store.dispatch('addToolShape', newShape);
    store.dispatch('setDropped', null);

    local.path = null;
    store.dispatch('setWhiteboardTool', 'selecter');
    PathUtils.autoZoomOn(store.getters.shapes);
    return false;
}

export const CircleTool = new Tool({
    name: 'circle',
    onActivate
});
